export enum TransactionTypeEnum {
  EXPENSE = 'EXPENSE',
  INCOME = 'INCOME'
}
